// extracted by mini-css-extract-plugin
module.exports = {"posterSection":"section-styles-module--posterSection--2QpZb"};